export default __webpack_public_path__ + "static/media/image.gr8impressions.6278b1b2.png";